<!-- ── CASHFLOW STEP 1 — Location & Buyer ── -->
<app-ip-shell [activeStep]="1" [steps]="cfSteps" calculatorName="Cash Flow Calculator">

  <!-- ── FORM COLUMN ── -->
  <div formCol>
    <div class="ip-form-head">
      <div class="ip-form-head__step-meta">Step 01 &middot; Cash Flow Calculator</div>
      <h1 class="ip-form-head__title">Where would you like to invest?</h1>
      <p class="ip-form-head__subtitle">
        Enter any UK postcode or select any city to explore investment potential
      </p>
    </div>

    <div class="ip-form-body">

      <!-- City search -->
      <div class="ip-field">
        <label class="ip-field__label">Location</label>
        <div class="ip-input ip-search-input">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
          </svg>
          <input
            type="text"
            class="ip-input__field"
            placeholder="Search postcode or city..."
            [(ngModel)]="searchQuery"
            autocomplete="off">
        </div>
      </div>

      <!-- Popular areas -->
      <div class="ip-field">
        <label class="ip-field__label">Popular areas</label>
        <div class="ip-chip-row">
          <button class="ip-chip" *ngIf="'London'     | cityFilter:searchQuery" [class.is-active]="City==='London'"     (click)="selectCity('London','SW1A 1AA',51.5074,-0.1278)"     type="button">London</button>
          <button class="ip-chip" *ngIf="'Liverpool'  | cityFilter:searchQuery" [class.is-active]="City==='Liverpool'"  (click)="selectCity('Liverpool','L1 1AA',53.4084,-2.9916)"     type="button">Liverpool</button>
          <button class="ip-chip" *ngIf="'Manchester' | cityFilter:searchQuery" [class.is-active]="City==='Manchester'" (click)="selectCity('Manchester','M1 1AA',53.4808,-2.2426)"   type="button">Manchester</button>
          <button class="ip-chip" *ngIf="'Birmingham' | cityFilter:searchQuery" [class.is-active]="City==='Birmingham'" (click)="selectCity('Birmingham','B1 1AA',52.4862,-1.8904)"   type="button">Birmingham</button>
        </div>
      </div>

      <!-- Buyer status -->
      <div class="ip-field" *ngIf="City">
        <div class="ip-field__head">
          <label class="ip-field__label">Buyer status</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Affects SDLT calculation</span>
        </div>
        <div class="ip-buyer-cards">
          <button class="ip-buyer-card" [class.is-active]="foreignbuyer!=='1'" (click)="foreignbuyer='0'" type="button">
            <span class="ip-buyer-card__title">UK Resident</span>
            <span class="ip-buyer-card__sub">Standard investment stamp duty rates apply</span>
          </button>
          <button class="ip-buyer-card" [class.is-active]="foreignbuyer==='1'" (click)="foreignbuyer='1'" type="button">
            <span class="ip-buyer-card__title">Foreign Buyer</span>
            <span class="ip-buyer-card__sub">Additional 2% non-resident surcharge applies</span>
            <span class="ip-buyer-card__sdlt-note">+2% SDLT surcharge</span>
          </button>
        </div>
      </div>

      <!-- Purchase type (shown once a city is selected) -->
      <div class="ip-field" *ngIf="City">
        <div class="ip-field__head">
          <label class="ip-field__label">Purchase type</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Determines SDLT rate band</span>
        </div>
        <div class="ip-buyer-cards">
          <button class="ip-buyer-card" [class.is-active]="buyerType==='ftb'" (click)="buyerType='ftb'" type="button">
            <span class="ip-buyer-card__title">First Time Buyer</span>
            <span class="ip-buyer-card__sub">You have never owned a property before.</span>
            <span class="ip-buyer-card__sdlt-note">0% up to £300k · FTB relief</span>
          </button>
          <button class="ip-buyer-card" [class.is-active]="buyerType==='investment'" (click)="buyerType='investment'" type="button">
            <span class="ip-buyer-card__title">Investment / 2nd Property</span>
            <span class="ip-buyer-card__sub">Buying an additional residential property.</span>
            <span class="ip-buyer-card__sdlt-note">+ 5% additional dwelling surcharge</span>
          </button>
        </div>
      </div>

      <!-- Home currency (foreign buyers only) -->
      <div class="ip-field" *ngIf="foreignbuyer==='1'">
        <div class="ip-field__head">
          <label class="ip-field__label">Home currency</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Returns shown in your currency</span>
        </div>
        <div class="s3-currency-wrap" id="currencySelectWrap">
          <button
            type="button"
            class="s3-currency-btn"
            (click)="currencyDropdownOpen=!currencyDropdownOpen"
            [class.open]="currencyDropdownOpen">
            <span class="s3-currency-val" [class.placeholder]="!homecurrencyText">
              {{ homecurrencyText ? getCurrencyLabel(homecurrencyText) : 'Select currency' }}
            </span>
            <svg class="s3-currency-chevron" [class.rotated]="currencyDropdownOpen" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
          </button>
          <div class="s3-dropdown" *ngIf="currencyDropdownOpen">
            <div class="s3-dropdown__search">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
              <input
                type="text"
                class="s3-dropdown__input"
                placeholder="Search currency..."
                [(ngModel)]="currencySearch"
                autocomplete="off"
                (click)="$event.stopPropagation()">
            </div>
            <div class="s3-dropdown__list">
              <div
                *ngFor="let c of getFilteredCurrencies()"
                class="s3-dropdown__item"
                [class.selected]="homecurrencyText === c.code"
                (click)="selectCurrency(c.code)">
                <span class="s3-dropdown__item-name">{{ c.name }}</span>
                <span class="s3-dropdown__item-code">{{ c.code }}</span>
              </div>
              <div class="s3-dropdown__empty" *ngIf="getFilteredCurrencies().length === 0">No currencies found</div>
            </div>
          </div>
        </div>
      </div>

      <!-- FX Rate (foreign buyers, read-only) -->
      <div class="ip-field" *ngIf="foreignbuyer==='1' && homecurrencyText && homecurrency">
        <div class="ip-field__head">
          <label class="ip-field__label">FX rate (1 GBP)</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Live rate</span>
        </div>
        <div class="ip-input">
          <input type="text" class="ip-input__field" [value]="homecurrency || '—'" readonly>
          <span class="ip-input__suffix">{{ homecurrencyText }}</span>
        </div>
      </div>

    </div><!-- /ip-form-body -->

    <div class="ip-form-actions">
      <button class="ip-btn ip-btn--ghost" type="button" (click)="router.navigate(['/'])">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back
      </button>
      <button class="ip-btn ip-btn--primary" type="button" (click)="next()">
        Continue
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div><!-- /formCol -->

  <!-- ── RAIL ── -->
  <div rail>
    <div class="ip-rail-marketing">
      <div class="ip-rail-marketing__eyebrow">Cash Flow Calculator</div>
      <h2 class="ip-rail-marketing__title">
        Invest in <em>{{ City || 'UK' }}'s</em> Future
      </h2>
      <p class="ip-rail-marketing__lede">
        Model your annual net cash flow, year-by-year breakdown, and total returns before you commit.
      </p>
      <div class="ip-rail-marketing__divider-label">{{ City || 'UK Market' }} Snapshot</div>
      <div class="ip-rail-stats">
        <div class="ip-rail-stat">
          <span class="ip-rail-stat__label">Average yield</span>
          <span class="ip-rail-stat__value">{{ getHeroYield() }}</span>
        </div>
        <div class="ip-rail-stat">
          <span class="ip-rail-stat__label">5-year growth</span>
          <span class="ip-rail-stat__value">{{ getHeroGrowth() }}</span>
        </div>
        <div class="ip-rail-stat">
          <span class="ip-rail-stat__label">UK BTL ranking</span>
          <span class="ip-rail-stat__value">
            {{ City === 'Manchester' ? '#1' : City === 'Liverpool' ? '#2' : City === 'Birmingham' ? '#3' : 'Top UK' }}
          </span>
        </div>
        <div class="ip-rail-stat" *ngIf="foreignbuyer==='1' && homecurrencyText && homecurrency">
          <span class="ip-rail-stat__label">£1 =</span>
          <span class="ip-rail-stat__value">{{ homecurrency }} <sup>{{ homecurrencyText }}</sup></span>
        </div>
      </div>
    </div>
  </div><!-- /rail -->

</app-ip-shell>
